import { useCallback } from "react"
import { ICanceledProjectExport, IProjectExport } from "../../application/models"
import { useAxiosInstances } from "../axios-instance"
import { IProjectExportContent } from "../../application/models/IProjectExportContent"
import { ICompareExportContentWithBlacklistResponse } from "../../application/models/ICompareExportContentWithBlacklistResponse"

export const useProjectExportApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const findProjectExportByUserIdApi = useCallback((data: {
    userId: string;
    limit?: number;
    page?: number;
    filters?: {
      name?: string
      companyId?: string
      createdBy?: string
      startDate?: Date
      endDate?: Date
      type?: string
    };
  }): Promise<{
    projectExportList: {
      projectExport: IProjectExport
      fileExists: boolean
      canceledProjectExport?: ICanceledProjectExport
    }[]
    total: number
    page: number
  }> => {

    return axiosAuthInstance.get('/routes/project-export', {
      params: {
        userId: data.userId,
        limit: data.limit,
        page: data.page,
        name: data.filters?.name,
        companyId: data.filters?.companyId,
        createdBy: data.filters?.createdBy,
        startDate: data.filters?.startDate,
        endDate: data.filters?.endDate,
        type: data.filters?.type
      }
    }).then((response) => {
      const result = response.data.result
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
      throw err
    })
  }, [axiosAuthInstance])

  /* This method will download the file using s */
  /* The endpoint use streams to download the file */

  const downloadProjectExportApi = useCallback((data: {
    projectExportId: string,
    exportLayoutId: string,
    fileExt: string
  }): Promise<any> => {
    return axiosAuthInstance.get('/routes/project-export/download', {
      params: {
        ...data
      }
    }).then((response) => {

      const result = response.data.result
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
      console.error('[downloadProjectExportApi] Erro:', err);
      throw err;
    })
  }, [axiosAuthInstance])

  const checkExportFile = useCallback((data: {
    projectExportId: string,
  }): Promise<boolean> => {
    return axiosAuthInstance.get('/routes/project-export/check-file', {
      params: {
        ...data
      }
    }).then((response) => {
      const result = response.data.result.exists
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
    })
  }, [axiosAuthInstance])

  const recreateExportFileApi = useCallback((data: {
    projectExportId: string,
  }): Promise<boolean> => {
    return axiosAuthInstance.put('/routes/project-export/recreate-file', {
      ...data
    }).then((response) => {
      const result = response.data.result.exists
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
    })
  }, [axiosAuthInstance])

  const getExportStatusApi = useCallback((data: {
    projectExportId: string,
  }): Promise<{
    status: 'pending' | 'completed' | 'failed' | 'processing',
    progress?: number
  }> => {

    return axiosAuthInstance.get('/routes/project-export/status', {
      params: {
        ...data
      }
    }).then((response) => {
      const result = response.data.result
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    })
  }, [
    axiosAuthInstance
  ])

  const createCanceledProjectExportApi = useCallback((data: {
    resourceId: string
    whoCanceled: string
  }): Promise<Partial<ICanceledProjectExport>> => {
    return axiosAuthInstance.post('/routes/canceled-project-export', data).then((response) => {
      const result = response.data.result

      if (result) {
        return result
      } else {
        throw new Error('Falha ao cancelar extração')
      }
    })
  }, [axiosAuthInstance])

  const getProjectExportContentApi = useCallback((projectExportId: string): Promise<IProjectExportContent> => {
    return axiosAuthInstance
      .get("/routes/project-export/content/" + projectExportId)
      .then(response => {
        const content = response.data.result?.projectExportContent;
        if (content) return content;
        throw new Error("Conteúdo não encontrado");
      })
      .catch(err => {
        console.error("[getProjectExportContentApi] Erro:", err);
        throw err;
      });
  }, [axiosAuthInstance]);
  
  const compareExportContentWithBlacklistApi = useCallback((exportId: string): Promise<ICompareExportContentWithBlacklistResponse> => {
    return axiosAuthInstance
      .post(`/routes/project-export/compare-with-blacklist/${exportId}`)
      .then(response => {
        const result = response.data.result;
        if (result) return result;
        throw new Error("Resultado não encontrado");
      })
      .catch(err => {
        console.error("[compareExportContentWithBlacklistApi] Erro:", err);
        throw err;
      });
  }, [axiosAuthInstance]);

  return {
    compareExportContentWithBlacklistApi,
    getProjectExportContentApi,
    findProjectExportByUserIdApi,
    downloadProjectExportApi,
    checkExportFile,
    recreateExportFileApi,
    getExportStatusApi,
    createCanceledProjectExportApi
  }
 }